import React from 'react';
import meta from '../../const/meta';
import { Regions } from '../Styled/Buttons/icons';
import SubPage from '../MaterialUI/subpage';

const items = [
  {
    url: meta.cat.provinces.frontend,
    title: 'Області',
    icon: Regions,
    desc: 'Області',
  },
  {
    url: meta.cat.regions.frontend,
    title: 'Регіональні ознаки (старостинства)',
    icon: Regions,
    section: 'region',
    desc: 'Довідник регіональних ознак та старостинств',
  },
  {
    url: meta.cat.zones.frontend,
    title: 'Довідник зон населених пунктів',
    desc: 'Довідник зон населених пунктів',
    icon: Regions,
  },
  {
    url: meta.cat.districts.frontend,
    title: 'Довідник районів області',
    desc: 'Довідник районів області',
    icon: Regions,
  },
  {
    url: meta.cat.localities.frontend,
    title: 'Довідник населених пунктів',
    desc: 'Довідник населених пунктів',
    icon: Regions,
  },
  {
    url: meta.cat.areas.frontend,
    title: 'Довідник районів міста',
    desc: 'Довідник районів міста',
    icon: Regions,
  },
  {
    url: meta.cat.streets.frontend,
    title: 'Довідник вулиць',
    desc: 'Довідник вулиць',
    icon: Regions,
  },
  {
    url: meta.cat.houses.frontend,
    title: 'Довідник будинків',
    desc: 'Довідник будинків',
    icon: Regions,
  },
];

function AddrPage() {
  return <SubPage pageTitle="Адресний класифікатор" items={items} />;
}

export default AddrPage;
